/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-arrow-up': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" _fill="#fff" fill-rule="evenodd" d="M5 13a1 1 0 002 0V3.414l3.293 3.293a1 1 0 001.414-1.414l-5-5-.01-.01A.992.992 0 006.016 0H5.99m-.004 0a.993.993 0 00-.706.306l-.001.001-.128.133-.359.37c-.306.315-.735.755-1.229 1.256-.99 1.004-2.23 2.243-3.25 3.207a1 1 0 101.374 1.454c1.047-.989 2.307-2.25 3.3-3.257L5 3.457V13" clip-rule="evenodd"/>'
  }
})
